import { gql } from '@apollo/client';

export const LIST_DEVICES_QUERY = gql`
  query ListDevices($input: ListDevicesInput!) {
    listDevices(input: $input) {
      devices {
        ... on Terminal {
          id
          typename: __typename
          address
          approvalsCount
          location {
            lat
            lon
          }
          notes
          organization
          registrationDate
          status
          user {
            id
          }
        }
      }
      total
    }
  }
`;
